// extracted by mini-css-extract-plugin
export default {"orderButton":"style_orderButton__OUrL+","menuIcon":"style_menuIcon__kMDF+","actionBtn":"style_actionBtn__ncoa2"};